import { render, staticRenderFns } from "./BlankState.vue?vue&type=template&id=2f7f00b8&"
import script from "./BlankState.vue?vue&type=script&lang=js&"
export * from "./BlankState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports